import { get, post, put, destroy } from '.';

export function GetEmailTemplates(options = {}) {
	return get<any>("/app/api/email_templates", options);
}

export function FindEmailTemplate(vid: string, options = {}) {
	return get<any>(`/app/api/email_templates/${vid}`, options);
}

export function CreateEmailTemplate(options = {}) {
	return post<any>("/app/api/email_templates", options);
}

export function CopyEmailTemplate(id: string, options = {}) {
	return post<any>(`/app/api/email_templates/${id}`, options);
}

export function UpdateEmailTemplate(id: string, options = {}) {
	return put<any>(`/app/api/email_templates/${id}`, options);
}

export function DestroyEmailTemplate(id: string, options = {}) {
	return destroy<any>(`/app/api/email_templates/${id}`, options);
}